import angular from 'angular';
import { NsjRoutingType } from '../../../../core/nsj-core';
import { LoadParams } from '../../../../shared/models/loadparams.model';
import {
    IGeracaoDeMarcacoesPadraoListItem,
    IGeracaoDeMarcacoesPadraoConstructor,
    IGeracaoDeMarcacoesPadraoOffset,
    IGeracaoDeMarcacoesPadraoCreate,
    IGeracaoDeMarcacoesPadraoReversaoParcial,
    IGeracaoDeMarcacoesPadraoReversaoTotal,
    IGeracaoDeMarcacoesPadraoPreview,
    IGeracaoDeMarcacoesPadraoGet,
    IGeracaoDeMarcacoesPadraoLog,
    IGeracaoDeMarcacoesPadraoHistorico,
    IGeracaoDeMarcacoesPadraoColaboradorAfetado,
    IGeracaoDeMarcacoesPadraoHistoricosDisponiveis
} from './models/geracao-de-marcacoes-padrao.service.model';

export class GeracaoDeMarcacoesPadraoService {

    static $inject = ['$rootScope', '$http', '$q', 'nsjRouting'];

    public entities: IGeracaoDeMarcacoesPadraoListItem[] = [];
    public loaded = false;
    public constructors: IGeracaoDeMarcacoesPadraoConstructor = {};
    public after: IGeracaoDeMarcacoesPadraoOffset = {};
    public loadParams = new LoadParams();
    public loading_deferred: angular.IDeferred<unknown>;
    public filter = '';

    constructor(
        public $rootScope: angular.IRootScopeService,
        public $http: angular.IHttpService,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) { }

    reload() {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.after = {};
        this.loaded = false;
        this.entities = [];
        this.loadParams = new LoadParams();
        this.loadParams.to_load = 1;

        return this.load();
    }

    loadMore() {
        this.loadParams.to_load = 1;
        this.load();
    }

    _load(constructors: IGeracaoDeMarcacoesPadraoConstructor, offset: IGeracaoDeMarcacoesPadraoOffset, filter: string) {
        this.loading_deferred = this.$q.defer();

        return this.$q<IGeracaoDeMarcacoesPadraoListItem[]>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoListItem[]>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_index',
                    angular.extend({}, constructors, {
                        'offset': offset,
                        'filter': filter
                    }),
                true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    }

    load() {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data) => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                        this.after = {
                            importacaomarcacao: this.entities[this.entities.length - 1]['importacaomarcacao']
                        };
                    }

                    this.loaded = true;
                    this.loadParams.to_load--;
                    this.loadParams.finished = true;
                    this.$rootScope.$broadcast('ponto_importacoesmarcacoes_index_finished', this.entities);
                })
                .catch((error) => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally(() => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                    this.load();
                });
        }

        return this.entities;
    }

    previewGeracao(apuracaoponto: string, entity: IGeracaoDeMarcacoesPadraoCreate) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IGeracaoDeMarcacoesPadraoPreview>, reject) => {
            this.$http.post<IGeracaoDeMarcacoesPadraoPreview>(
                this.nsjRouting.generate('ponto_apuracoesponto_preview_importacao_marcacoes_padrao', {
                    apuracaoponto
                }, true), entity, {
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_preview_importacao_marcacoes_padrao_preview_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_preview_importacao_marcacoes_padrao_preview_error', response);
                reject(response);
            });
        });
    }

    gerar(apuracaoponto: string, entity: IGeracaoDeMarcacoesPadraoCreate) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<{}>, reject) => {
            this.$http.post<{}>(
                this.nsjRouting.generate('ponto_apuracoesponto_gerar_importacao_marcacoes_padrao', {
                    apuracaoponto
                }, true), entity, {
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_gerar_importacao_marcacoes_padrao_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_gerar_importacao_marcacoes_padrao_error', response);
                reject(response);
            });
        });
    }

    reverter(params: { apuracaoponto: string, importacaomarcacao: string }, entity: IGeracaoDeMarcacoesPadraoReversaoTotal | IGeracaoDeMarcacoesPadraoReversaoParcial) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<{}>, reject) => {
            this.$http.post<{}>(
                this.nsjRouting.generate('ponto_apuracoesponto_reversao_importacao_marcacoes_padrao', {
                    ...params
                }, true), entity, {
                timeout: this.loading_deferred.promise
            })
            .then((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_reversao_importacao_marcacoes_padrao_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_apuracoesponto_reversao_importacao_marcacoes_padrao_error', response);
                reject(response);
            });
        });
    }

    get(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IGeracaoDeMarcacoesPadraoGet>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoGet>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_get_error', response);
                reject(response);
            });
        });
    }

    getLog(importacaomarcacao: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IGeracaoDeMarcacoesPadraoLog>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoLog>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_log', {
                    importacaomarcacao
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_log_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_log_error', response);
                reject(response);
            });
        });
    }

    getHistorico(importacaomarcacao: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IGeracaoDeMarcacoesPadraoHistorico[]>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoHistorico[]>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_historico', {
                    importacaomarcacao
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_historico_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_historico_error', response);
                reject(response);
            });
        });
    }

    getHistoricosDisponiveis() {
        this.loading_deferred = this.$q.defer();
        return this.$q<IGeracaoDeMarcacoesPadraoHistoricosDisponiveis[]>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoHistoricosDisponiveis[]>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_historicos_disponiveis', {}, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_historicos_disponiveis_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_historicos_disponiveis_error', response);
                reject(response);
            });
        });
    }

    getColaboradoresAfetados(importacaomarcacao: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<IGeracaoDeMarcacoesPadraoColaboradorAfetado[]>((resolve, reject) => {
            this.$http.get<IGeracaoDeMarcacoesPadraoColaboradorAfetado[]>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_trabalhadores_afetados', {
                    importacaomarcacao
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_trabalhadores_afetados_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_trabalhadores_afetados_error', response);
                reject(response);
            });
        });
    }

    exportarXlsx(importacaomarcacao: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q<Blob>((resolve, reject) => {
            this.$http.get<Blob>(
                this.nsjRouting.generate('ponto_importacoesmarcacoes_exportacao', {
                    importacaomarcacao
                }, true), {
                    timeout: this.loading_deferred.promise,
                    responseType: 'blob',
                }
            )
            .then((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_exportacao_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('ponto_importacoesmarcacoes_exportacao_error', response);
                reject(response);
            });
        });
    }
}
